module.exports = __webpack_public_path__ + "img/instore.ebc0c25d.png";